import BaseApiService from './BaseApiService'

export interface OAuthConnection {
  oAuthConnectionId: string
  provider: string
  accountLabel: string
  expiresAt: string | null
  scope: string | null
  createdAt: string
  hasRefreshToken: boolean
}

class IntegrationsApiService extends BaseApiService {
  listConnections(): Promise<OAuthConnection[]> {
    return this.get<OAuthConnection[]>('/v1/integrations/connections')
  }

  getAuthorizeUrl(provider: string): Promise<{ authUrl: string }> {
    return this.get<{ authUrl: string }>(`/v1/integrations/authorize?provider=${encodeURIComponent(provider)}`)
  }

  deleteConnection(id: string): Promise<void> {
    return this.httpDelete<void>(`/v1/integrations/connections/${id}`)
  }
}

export const integrationsApiService = new IntegrationsApiService()
